
import UserInfo from '@/mobileComponents/UserInfo'

export default {
  data() {
    return {
      // 消息列表
      noticeData: [],
      activeName: '0',
      // 当前页面
      currentPage: 1,
      // 每页的数量
      pageNum: 10,
      // 总页数
      total: 0,
      showLoading: true
    }
  },
  components: {
    UserInfo
  },
  created() {
    this.getnotice()
  },
  methods: {
    onClickLeft() {
      window.history.back()
    },
    // 获取站内信通知
    async getnotice() {
      const { data } = await this.$http.post('/notice/noticedata', {
        page: this.currentPage,
        eachpage: this.pageNum
      })
      if (data.status === 'success') {
        this.noticeData = data.data
        this.total = data.total
        this.showLoading = false
      } else {
        this.$notify({
          type: 'danger',
          message: data.msg
        })
        this.showLoading = false
      }
    }
  }
}
